{
  "version": 1,
  "asset_id": "e3c7a4a3-9292-4b5b-93b0-d2b5db178d7e",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/e3c7a4a3-9292-4b5b-93b0-d2b5db178d7e/clip-img_0226-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/e3c7a4a3-9292-4b5b-93b0-d2b5db178d7e/clip-img_0226-poster-sm.webp",
  "original_filename": "clip-img_0226-poster-sm.webp",
  "size": 111506,
  "content_type": "image/webp",
  "created_at": "2026-08-15T18:07:52Z"
}
